export default "__VITE_ASSET__BexIGKl9__"